import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform  } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef }  from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ServiceInvoiceService, CommonService, SubscribeService } from '../../../services/index';
import { ServiceInvoiceModel } from '../../../model/index';

@Component({
    selector: 'addeditServiceInvoice-tab',
    templateUrl: './addEditServiceInvoice.component.html',
})
export class AddEditServiceInvoiceComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    //public salesbilltypesdata: any[] = [];

    isLoadMask: Promise<any>;
    //salesbilltypesData: SalesBillentryModel[];
    isLoading: boolean = false;
    minDate: any;

    @Input() servicegriddata: ServiceInvoiceModel[] = [];
    //@Input() serviceInvoice: ServiceInvoiceModel[] = [];
    partyCtrl: FormControl;
    srfCtrl: FormControl;
    typeCtrl: FormControl;
    servicetypeCtrl: FormControl;
    modelCtrl: FormControl;
    filteredParty: Observable<any[]>;
    filteredSrf: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    SrfList = [];
    ModelList = [];
    serviceInvoice = [];
    typeList = [];
    servicetypeList = [];
    actModelList = [];

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    reorderable: boolean = true;
    page = {
        limit: 100,
        count: 0,
        offset: 0,
        orderBy: 'purchase_id',
        orderDir: 'asc'
    };
    columns = [];
    serviceInvoiceDetails = [];

    constructor(private modalService: BsModalService,
     private serviceInvoiceService: ServiceInvoiceService,
      private commonService: CommonService, 
      public snackBar: MdSnackBar,
       public toasterService: ToasterService,
        public subscribeService: SubscribeService) {

        //this.halistCtrl = new FormControl();
          //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidParty(input: FormControl) {
            let partyID = input.value, retVal = null;
            if (partyID == "") {
                retVal = { inValidParty: true };
            }
            if (partyID && typeof partyID === 'string') {
                retVal = { inValidParty: true };
            }
            return retVal;
        }
        this.partyCtrl = new FormControl('', [
            Validators.required,
            hasValidParty.bind(this)
        ]);
        this.filteredParty = this.partyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterParty(name) : this.PartyList.slice());


        function hasValidSrf(input: FormControl) {
            let srfID = input.value, retVal = null;
            if (srfID == "") {
                retVal = { inValidSrf: true };
            }
            if (srfID && typeof srfID === 'string') {
                retVal = { inValidSrf: true };
            }
            return retVal;
        }
        this.srfCtrl = new FormControl('', [
            Validators.required,
            hasValidSrf.bind(this)
        ]);
        this.filteredSrf = this.srfCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrf(name) : this.SrfList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredModel = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterModel(name) : this.ModelList.slice());

         //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "HA Model" && ledgerID != "Spare" ) {
                retVal = { inValidType: true };
            }
          
            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);

         //FOR AUTO COMPLETE VALIDATION --- service TYPE
        function hasValidPurType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Normal" && ledgerID != "Service" ) {
                retVal = { inValidType: true };
            }
          
            return retVal;
        }
        this.servicetypeCtrl = new FormControl('', [
            Validators.required,
            hasValidPurType.bind(this)
        ]);
    }

    ngOnInit(): void {
        let that = this;
     
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 60, minWidth: 60, maxWidth: 60, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'SRF NO', prop: 'srf_no', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left'},
            { name: 'Client', prop: 'client_name', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-left' },
            { name: 'Branch', prop: 'company_name', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-left' },
            //{ name: 'Machine', prop: 'serial_no', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-left' },
            { name: 'Service Amount', prop: 'amount', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-right' }
           
            //{ name: 'Action', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

    
        //TO LOAD PARTY LIST
        this.loadPartyList();
        this.loadSrfList();
        //TO LOAD MODEL STOCK LIST
        //this.loadStockModelList();
        this.typeList = ['HA Model', 'Spare'];
        this.servicetypeList = ['Normal', 'Service'];

        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.serviceInvoice['date'] = new Date();
        } 

    }
/*     pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getserviceInvoiceDetailList();
    } */
       loadPartyList() {
        let that = this;
        this.commonService
            .getPartyList()
            .then(function(res: any) {
                if (res.success) {
                    that.PartyList = res.data;
                    that.partyCtrl.setValue(that.serviceInvoice['party_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadSrfList() {
        let that = this;
        this.commonService
            .getSrfList()
            .then(function(res: any) {
                if (res.success) {
                    that.SrfList = res.data;
                    that.srfCtrl.setValue(that.serviceInvoice['ser_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }


    loadStockModelList() {
        let that = this,
            data = {
                type: 'All',
                comp_stock: 'No'
            };
        this.commonService
            .getStockModelList(data)
            .then(function(res: any) {
                if (res.success) {
                    that.actModelList = res.data;
                    //that.ModelList = res.data;
                    //that.modelCtrl.setValue(that.serviceInvoice['model_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    onSelectedType(typeName) {
        
        this.ModelList = [];
        this.ModelList = _.filter(this.actModelList, { 'from_page': typeName });
        this.modelCtrl.setValue(this.serviceInvoice['model_id']);
    }
    filterParty(name: string) {
        name = _.escapeRegExp(name);
        return this.PartyList.filter(item => (new RegExp(name, 'gi').test(item.party_name)));
    }

    displayPartyFn(partyID: number) {
        if (partyID && this.PartyList.length > 0) {
            let fitem = _.find(this.PartyList, { 'party_id': partyID });
            return fitem['party_name'];
        }
        return '';
    }

    filterSrf(name: string) {
        name = _.escapeRegExp(name);
        return this.SrfList.filter(item => (new RegExp(name, 'gi').test(item.srf_no)));
    }

    displaySrfFn(srfID: number) {
        if (srfID && this.SrfList.length > 0) {
            let fitem = _.find(this.SrfList, { 'ser_id': srfID });
            return fitem['srf_no'];
        }
        return '';
    }

    filterModel(name: string) {
        name = _.escapeRegExp(name);
        return this.ModelList.filter(item => (new RegExp(name, 'gi').test(item.model_id)
          || new RegExp(name, 'gi').test(item.name)  ));
    }

    displayModelFn(modelID: number) {
        if (modelID && this.ModelList.length > 0) {
            let fitem = _.find(this.ModelList, { 'model_id': modelID });
            this.servicegriddata['model_name'] =fitem['name'];
            this.servicegriddata['mrp'] =fitem['mrp'];
            return fitem['name'];
        }
        return '';
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'empid';
        }
        $('#' + nextEl).focus();
    }
 
    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'Purchase Invoice',
                date: moment(this.serviceInvoice['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function(res: any) {
                if (res['success']) {
                    that.serviceInvoice['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    
    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.serviceInvoice = Object.assign({}, this._params);
            if (mode != 'Add') {
                this.serviceInvoice['hidden_srf'] = this._params['srf_no'];
                this.checkSrf(this._params);
                this.serviceInvoice['date'] = new Date(this._params['date']);//new Date();
                this.serviceInvoice['hidden_party'] = this._params['party_name'];
                this.servicegriddata['mrp_value'] = this._params['service_amount'];
                this.servicegriddata['tax'] = this._params['service_tax'];
                this.serviceInvoice['hidden_type']=this._params['type'];
                this.calAmount();
            }
        }
    }

   
   

    getServiceInvoiceDetailList(): void {
        let that = this,
            mode = this._params['mode'],
            bill_type = this.serviceInvoice['tabParams'],
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderBy: 'purchase_id',
                orderDir: `${this.page.orderDir}`,
                purchase_id: this.serviceInvoice['purchase_id'],
                mode: this._params['mode']
            };
        this.isLoadMask = this.serviceInvoiceService
            .getServiceInvoiceDetailList(params)
            .then(function(res: any) {
                if (res.success) {
                    that.page.count = res.totCnt;
                    that.serviceInvoiceDetails = res.data;
                        that.calGrantTotal('all');
                }
            });
    }

       checkSrf(mdCompEvent: any) {
       let that = this,
            data = {
                ser_id: mdCompEvent.ser_id
            };
        this.isLoadMask = this.serviceInvoiceService
            .checkSrf(data)
            .then(function(res: any) {
                if (res.success) {
                    //that.page.count = res.totCnt;
                    //that.serviceInvoice['srf_no'] = res.srf_no;
                    //that.serviceInvoiceDetails = res.data;
                    //let testDet = Object.assign({}, res.data);
                            that.serviceInvoiceDetails = [];
                            that.serviceInvoice['receipt_no'] = res.data[0].manufacture_receiptNo;
                            that.page.count = res.totCnt;
                            that.serviceInvoiceDetails.push(res.data[0]);
                            //that.page.count = that.serviceInvoiceDetails.length;
                    //swal('SRF Details', res.message);
                   
                        //that.calGrantTotal('all');
                }
            });
    }

   
  

    onDeleteserviceInvoiceEntry(row: any): void {
        let that = this,
            mode = this._params['mode'];

       
        if (mode == 'Add') {
            this.serviceInvoiceDetails.splice(this.serviceInvoiceDetails.indexOf(row), 1);
            //this.servicegriddata = [];

            this.calGrossTotal();
            this.clearRoundoff();
        } else {
            let params = {
                stock_type: row.stock_type,
                model_id: row.model_id,
                model_name: row.model_name,
                act_qty: row.act_qty,
                mrp: row.mrp,
                purchase_id: row.purchase_id,
                bill_type: this.serviceInvoice['tabParams'],
                serial_no: row['serial_no']
            };

            //  this.servicegriddata = [];

            this.serviceInvoiceService
                .deleteGridList(params)
                .then(function(res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.serviceInvoiceDetails.splice(that.serviceInvoiceDetails.indexOf(row), 1);
                        swal('SUCCESS', res.message, 'success');
                        that.getServiceInvoiceDetailList();
                        that.calGrossTotal();
                        that.clearRoundoff();

                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }

    addServiceInvoice(): void {
        let that = this,
            mode = this.serviceInvoice['mode'],
            modelID = this.servicegriddata['model_id'],
            modelName = this.servicegriddata['model_name'],
            serialNo = this.servicegriddata['serial_no'],
            stockType = this.servicegriddata['stock_type'];
        if (!_.isEmpty(_.toString(modelID))) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.serviceInvoiceDetails, { 'model_id': modelID, 'serial_no': serialNo });

            if (preTestID) {
                swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
                return;
            }

          /*  let actQty = this.servicegriddata['act_qty'];
            if (_.isEmpty(actQty)){ // 11 > 10
                swal('WARNING', 'Enter Quantity ');
                return;
            }*/

      
            //HA = this.service
            if (_.isEmpty(serialNo)&& (stockType == 'HA Model') ){ // 11 > 10
                swal('WARNING', 'Enter SERIAL NO ');
                return;
            }
            let MRP = this.servicegriddata['mrp_value'];
            if (_.isEmpty(MRP)){ // 11 > 10
                swal('WARNING', 'Enter MRP ');
                return;
            }
            let TAX = this.servicegriddata['tax'];
            if (_.isEmpty(TAX)){ // 11 > 10
                /* swal('WARNING', 'Enter TAX ');
                return; */
                this.servicegriddata['tax']=0;
            }
            let DISCOUNT = this.servicegriddata['discount'];
            if (_.isEmpty(DISCOUNT)){ // 11 > 10
                /* swal('WARNING', 'Enter Discount ');
                return; */
                this.servicegriddata['discount'] = 0;

            } 

            
             let dataDet = {
                stock_type:stockType,
                model_id:modelID,
                model_name:modelName,
                serial_no:serialNo,
            }
            this.serviceInvoiceService
                    .getModelDetails(dataDet)
                    .then(function(res: any) {

                        if (res.success) {
                            swal('ERROR', res.message, 'error');
                            return;
                        } else { 
                         if (mode == 'Add') {
                let testDet = Object.assign({}, that.servicegriddata);
                that.serviceInvoiceDetails.push(testDet);
                if(that.servicegriddata['check'] == true){
                    if(that.servicegriddata['stock_type'] == 'HA Model'){
                        that.servicegriddata['serial_no'] == "";
                        $('#' + 'stock_serial_no').val("");
                        $('#' + 'stock_serial_no').focus();
                    }else{
                        that.servicegriddata = [];
                        $('#' + 'stock_type').focus();
                    }
                }else{
                    that.servicegriddata = [];
                        $('#' + 'stock_type').focus();
                }
                
             //   this.servicegriddata['amount'] = 0;
                that.page.count = that.serviceInvoiceDetails.length;
                that.calGrossTotal();
                that.clearRoundoff();
                //this.serialNoList = [];
            } else if (mode == 'Edit') {
                let params = {
                    start: `${that.page.offset}`,
                    limit: `${that.page.limit}`,
                    model_id: that.servicegriddata['model_id'],
                    model_name: that.servicegriddata['model_name'],
                    mrp: that.servicegriddata['mrp'],
                    mrp_value: that.servicegriddata['mrp_value'],
                    tax: that.servicegriddata['tax'],
                    discount: that.servicegriddata['discount'],
                    total_amount: that.servicegriddata['total_amount'],
                    act_qty: that.servicegriddata['act_qty'],
                    purchase_id: that.serviceInvoice['purchase_id'],
                    party_id: that.serviceInvoice['party_id'],
                    stock_type: that.servicegriddata['stock_type'],
                    serial_no: that.servicegriddata['serial_no']
                },
                    testDet = Object.assign({}, that.servicegriddata);

                that.serviceInvoiceService
                    .addServiceInvoice(params)
                    .then(function(res: any) {
                        that.isLoading = false;

                        if (res.success) {
                            swal('SUCCESS', res.message, 'success');
                            that.page.count = res.totCnt;
                            that.page.count = that.serviceInvoiceDetails.length;
                            that.serviceInvoiceDetails.push(testDet);
                            

                            if(that.servicegriddata['check'] == true){
                    if(that.servicegriddata['stock_type'] == 'HA Model'){
                        that.servicegriddata['serial_no'] == "";
                        $('#' + 'stock_serial_no').val("");
                        $('#' + 'stock_serial_no').focus();
                    }else{
                        that.servicegriddata = [];
                        that.servicegriddata['amount'] = 0;
                        $('#' + 'stock_type').focus();
                    }
                }else{
                    that.servicegriddata = [];
                            that.servicegriddata['amount'] = 0;
                        $('#' + 'stock_type').focus();
                }
                            //that.servicegriddata = [];
                            //that.calAmount();

                           
                            that.calGrossTotal(); 
                            that.clearRoundoff();
                            that.getServiceInvoiceDetailList();
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
            }
                            
                        }
                        // return;
                    })
                  
           
          
        }
    }

  calModel() {
        let qty = 1;
        //this.servicegriddata = [];
        this.servicegriddata['act_qty'] = qty;
        //this.servicegriddata['serial_no'] = "qty";
        this.onSelectedType(this.servicegriddata['stock_type']);
    }
   calAmount() {
        let qty = 1,
            val = this.servicegriddata['mrp_value'],
            tax = this.servicegriddata['tax'],
            dis = 0,
            amt = 0,
            tot_amt=0,
            dis_amt=0;

        if (!_.isEmpty(_.toString(val))) {
            amt = (qty * val);

        } 
        if (!_.isEmpty(_.toString(tax))) {
               amt= ((amt)*(parseFloat(tax))/(100))+(amt);
            } 
       tot_amt = parseFloat(amt.toFixed(2)); toString

        if (!_.isEmpty(_.toString(dis))) {
               tot_amt= (tot_amt)-(dis);
            } 
              dis_amt = parseFloat(tot_amt.toFixed(2)); 

        this.servicegriddata['total_amount'] = dis_amt;
        this.calGrossTotal();
        this.clearRoundoff();
    }
    calGrossTotal() {
        let gross_total = this.servicegriddata['total_amount'];


        /*for (let i = 0; i < this.serviceInvoiceDetails.length; i++) {
            let total_amount = this.serviceInvoiceDetails[i].total_amount;
            gross_total += Number(total_amount);
           

        }*/
        this.serviceInvoice['gross_total'] = gross_total;
        //this.serviceInvoiceserviceInvoice['free_item'] = free;
  
        this.calGrantTotal('all');
    }

    calGrantTotal(from_field) {

        let gross_total = this.serviceInvoice['gross_total'],
            dis_per = this.serviceInvoice['discount_percentage'],
            discount_amount = this.serviceInvoice['discount_amount'],
            grant_total = 0;

        if (_.isEmpty(_.toString(gross_total))) {
            gross_total = 0;
        }
        if (!_.isEmpty(_.toString(dis_per))) {
            if (dis_per >= 0 && from_field == 'dis_per') {
                this.serviceInvoice['discount_amount'] = 0;
                discount_amount = (gross_total * dis_per) / 100;
                
            }
        } else {
            dis_per = 0;
            discount_amount = 0;
        }
        if (!_.isEmpty(_.toString(discount_amount)) && discount_amount != 0) {
            if (from_field == 'dis_amt')
                this.serviceInvoice['discount_percentage'] = 0;//(parseFloat(discount_amount) / parseFloat(gross_total)) * 100;
                dis_per = (discount_amount / gross_total) * 100;
                dis_per = (dis_per.toFixed(2)) / 1;

        } else {
            discount_amount = 0;
            dis_per = 0;
        }

        grant_total = (parseFloat(gross_total) - parseFloat(discount_amount));
        this.serviceInvoice['discount_percentage'] = dis_per;
        this.serviceInvoice['discount_amount'] = discount_amount;
        this.serviceInvoice['amount'] = grant_total;

     let  round = this.serviceInvoice['round_off'] || 0,
          value = grant_total + parseFloat(round);
           this.serviceInvoice['amount'] = value;
        
    }

    calRoundoff() {

        let grant_total = this.serviceInvoice['amount'],
            round = this.serviceInvoice['round_off'],
            value = 0;

       if (!_.isEmpty(_.toString(grant_total))) {
            value = (parseFloat(grant_total) - parseFloat(round));
        }
       
        this.serviceInvoice['amount'] = value;
        this.calGrossTotal();
    }

    clearRoundoff() {
        this.serviceInvoice['round_off'] = 0;
        this.calGrossTotal();
    }
    
    bsModalRef: BsModalRef;
    onSaveServiceInvoice(): void {
        let that = this,
            mode = this.serviceInvoice['mode'],
            advance = this.serviceInvoice['advances'],
            initial_amount = this.serviceInvoice['initial_amount'],
            //serviceInvoiceentry = this.serviceInvoiceDetails.length,
            qty = 1,
            amt = 0;
      
        /*if (serviceInvoiceentry == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }*/
       /* for (let i = 0; i < serviceInvoiceentry; i++) {
            amt += parseFloat(this.serviceInvoiceDetails[i].total_amount);
        }
        for (let i = 0; i < serviceInvoiceentry; i++) {
            qty += parseFloat(this.serviceInvoiceDetails[i].act_qty);
        }*/
        let serviceInvoiceDate = moment(this.serviceInvoice['date']).format('YYYY-MM-DD'),
            data = {
                purchase_id: this.serviceInvoice['purchase_id'],
                auto_no: this.serviceInvoice['auto_no'],
                receipt_no: this.serviceInvoice['receipt_no'],
                //srf_no: this.serviceInvoice['srf_no'],
                srf_no: '',
                service_type: this.serviceInvoice['service_type'],
                date: serviceInvoiceDate,
                party_id: this.serviceInvoice['party_id'],
                ser_id: this.serviceInvoice['ser_id'],
                type: this.serviceInvoice['stock_type'],
                //serviceInvoiceDetails: JSON.stringify(this.serviceInvoiceDetails),
                grand_total: this.serviceInvoice['amount'],
                gross_total: this.serviceInvoice['gross_total'],
                service_amount: this.servicegriddata['mrp_value'],
                service_tax: this.servicegriddata['tax'],
                discount_percentage: this.serviceInvoice['discount_percentage'],
                discount_amount: this.serviceInvoice['discount_amount'],
                round_off: this.serviceInvoice['round_off'],
                description: this.serviceInvoice['description'],
                mode: this.serviceInvoice['mode'],
                page_from: this.serviceInvoice['tabParams'],
                tot_qty: qty,
                amount: this.serviceInvoice['gross_total']
            };

  
        that.isLoading = true;
        this.serviceInvoiceService
            .addUpdateServiceInvoiceEntry(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.serviceInvoice = [];
                    that.serviceInvoiceDetails = [];
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadSalesBillentryListGrid();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceInvoice/addEditServiceInvoice.component.ts